import React from "react";
import { FaXmark } from "react-icons/fa6";

const TextModal = ({ isOpen, onClose, text, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[80vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaXmark size={24} />
          </button>
          <h2
            className="text-2xl font-bold text-gray-800"
            style={{ direction: "rtl" }}
          >
            {title}
          </h2>
        </div>

        {/* Content */}
        <div className="p-8 overflow-y-auto max-h-[60vh]">
          <div
            className="text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-800 text-center"
            style={{ direction: "rtl", lineHeight: "1.8" }}
          >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextModal;
